import { ref } from '@vue/composition-api'
import drawsApi from '@/services/api/draws'
import EventBus from '@/store/EventBus'

export default function useDrawsResult(eventId) {
  const results = ref([])
  const topCutout = ref([])
  const hasWinner = ref(false)
  const loading = ref(false)

  async function fetchResults(round) {
    loading.value = true
    try {
      const res = await drawsApi.getRoundResults(eventId, round)
      const data = res.data.data
      results.value = data.results != null ? data.results : []
      topCutout.value = data.topCutout != null ? data.topCutout : []
      hasWinner.value = data.hasWinner != null ? data.hasWinner : false
    } catch (_) {
      results.value = []
      topCutout.value = []
    } finally {
      loading.value = false
    }
  }

  async function setWinner(drawId) {
    try {
      const res = await drawsApi.setWinner(drawId)
      if (res.data.message) EventBus.$emit('show-success', res.data.message)
      const data = res.data.data
      if (data != null) {
        hasWinner.value = data.isWinner
      }
    } catch (_) { /* http.js handles toast */ }
  }

  return {
    results,
    topCutout,
    hasWinner,
    loading,
    fetchResults,
    setWinner
  }
}



// WEBPACK FOOTER //
// ./src/composables/draws/useDrawsResult.js